export enum PREDICTIVE_CREATE_COMPONENTS {
    ALGORITHM,
    ASSETS,
    CONFIGURATIONS,
    IMPACTED_KPIS
}

export enum THRESHOLD_CONDITION {
    EQUAL = "Equal",
    GREATER_THAN = "Greater than",
    LESS_THAN = "Less than"
}

export enum THRESHOLD_SYMBOL {
    "Equal" = '=',
    "Greater than" = '>',
    "Less than" = '<'
}

export enum PREDICTIVE_CONFIG_DROPDOWN_FIELDS {
    DEPARTMENT = "department",
    ROLE = "role",
    STATUS = "status",
    PRIORITY = "priority",
    THEME = "theme",
    SUB_TYPE ="subtype",
    ACTIONIN ="actionIn",
    FREQUENCY="frequencyUnit",
    THRESHOLDCONDITION="thresholdCondition",
}

export enum PREDICTIVE_CONFIG_ERROR {
    CONFIG_EXISTS = 'Configuration_Exists'
}

export enum MODAL_TITLE {
    SUBMIT_ISSUE = 'SUBMIT ISSUE',
}

export enum PREDICTIVE_CONFIG_ERROR_MODAL_MESSAGE {
    SUBMIT_ISSUE = 'Please select different assets, another user has already submitted same configuration on following Asset:',
}

export enum FREQUENCY_VALUE_MAX {
    "Hour" = 24,
    "Day" = 15,
    "Minute" = 60
}

export enum UOM_MEASUREMENT_TYPE {
    PERCENTAGE = 'percentage'
}